import React from 'react';

function StarSolid(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12.6456 2.39657L15.6195 8.28917L21.3434 8.8563C21.7372 8.88919 22.0296 9.23497 21.9976 9.62876C21.9834 9.79854 21.9096 9.95766 21.7878 10.0777L17.0772 14.7471L18.8237 21.0922C18.9259 21.478 18.6966 21.8735 18.3108 21.9758C18.1402 22.0211 17.9589 22.0024 17.8007 21.9233L11.9976 19.0495L6.20262 21.9198C5.84621 22.0993 5.41158 21.9553 5.23204 21.5989C5.15294 21.4406 5.13427 21.2593 5.1796 21.0886L6.92611 14.7436L2.21188 10.0741C1.93101 9.79588 1.92924 9.34253 2.20743 9.06252C2.32742 8.94074 2.48652 8.86696 2.65628 8.85274L8.3802 8.28561L11.3497 2.39657C11.5328 2.03834 11.9719 1.897 12.3292 2.08012C12.4652 2.15034 12.5763 2.26056 12.6456 2.39657Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default StarSolid;
